// extracted by mini-css-extract-plugin
module.exports = {"submit":"Registration-Page_submit__OcMRG"};